<ion-button #buttonField [disabled]="disabled" (click)="onButtonClick()">
  {{ label }}
</ion-button>
